module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/3mill-active-4dd247e650707ff8cc4f60e933ca27a6.png";